<div class="overlay-backdrop"></div>
<div class="message-overlay">
  <div class="spinner"></div>
  <p aria-live="polite">{{ message }}</p>
</div>
